export const VENDORLINK_NAMESPACE = 'VENDORLINK';
export const VENDORLINK_APPROVAL_POLICIES = 'APPROVAL_POLICIES';
export const VENDORLINK_ACCOUNT_USERS = 'ACCOUNT_USERS';
export const VENDORLINK_ADDRESSES = 'ADDRESSES';
export const VENDORLINK_ACCOUNTS = 'ACCOUNTS';
export const VENDORLINK_BANK_ACCOUNT_STATEMENTS = 'BANK_ACCOUNT_STATEMENTS';
export const VENDORLINK_DEPOSIT_ACCOUNTS = 'DEPOSIT_ACCOUNTS';
export const VENDORLINK_FINANCIALS = 'FINANCIALS';
export const VENDORLINK_FINANCIAL_REPORTS = 'REPORTS';
export const VENDORLINK_LEDGER_ACCOUNTS = 'LEDGER_ACCOUNTS';
export const VENDORLINK_JOURNAL_ENTRIES = 'JOURNAL_ENTRIES';
export const VENDORLINK_CARDS = 'CARDS';
export const VENDORLINK_BUDGET_SUMMARIES = 'BUDGET_SUMMARIES';
export const VENDORLINK_BUDGETS = 'BUDGETS';
export const VENDORLINK_PLAID_AUTH_ACCOUNTS = 'PLAID_AUTH_ACCOUNTS';
export const VENDORLINK_TRANSACTIONS = 'TRANSACTIONS';
export const VENDORLINK_CUSTOMERS = 'CUSTOMERS';
export const VENDORLINK_VENDORS = 'VENDORS';
export const VENDORLINK_BILLS = 'BILLS';
export const VENDORLINK_RECURRING_BILLS = 'RECURRING_BILLS';
export const VENDORLINK_INVOICES = 'INVOICES';
export const VENDORLINK_RECOGNIZED_INVOICES = 'RECOGNIZED_INVOICE';
export const VENDORLINK_INVOICE_OVERVIEW = 'INVOICE_OVERVIEW';
